import React from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { SearchForm, SearchFormProps, TableHeader } from '@occc-app/design-system';
import { Tab, Tabs } from '@occc/ui-design-system';

import { membershipReferralsTableMessages } from './membership-referrals-table.messages';

const tabValue = 'referrals';

type MembershipReferralsTableHeaderProps = {
  search: {
    value?: string;
    onSubmit: SearchFormProps['onSubmit'];
  };
};

export const MembershipReferralsTableHeader = (props: MembershipReferralsTableHeaderProps) => {
  const { search } = props;
  return (
    <TableHeader
      tabs={
        <Tabs value={tabValue}>
          <Tab value={tabValue} label={membershipReferralsTableMessages.tableHeaderTabLabel}></Tab>
        </Tabs>
      }
      actions={<SearchForm onSubmit={search.onSubmit} initialValues={{ search: search.value }} />}
    />
  );
};
